
<template>
  <div class="font app-content isVisitor bg-blue" >
    <b-container class='mt-4 px-0'>
      <b-row>

        <b-col cols='10' class='mx-auto px-0'>
          <b-row v-show="isShowDetailDate">
            <a @click="initCalendar()" class='text-orange'>＜ カレンダーに戻る</a>
          </b-row>
          <b-row v-show="!isShowDetailDate">
            <a href="/job_mypage" class='text-orange'>＜ TOPに戻る</a>
          </b-row>


          <b-row class='mt-4 border-bottom pb-2'>
            <b-col cols="12" class='px-0'>
              <h4 v-if="isShowDetailDate" class="org_title">{{ selectDate }}の面接日程</h4>
              <h4 v-else class="org_title py-3">今後の面接スケジュール</h4>
            </b-col>
            <b-col cols='4' class='px-0 text-right'>
              <router-link class='text-orange'>
                <b-button pill class='bg-orange mx-2' size="sm">{{$t("message.edit2")}}</b-button>
              </router-link>
            </b-col>
          </b-row>
          <div v-if="isShowDetailDate == false" class="pb-5 mb-5">
            <FullCalendar @dateClick="handleDateClick"  :options="calendarOptions" />
          </div>
          <div v-else>
            <b-row v-if="dayInterviews.length > 0" class='mt-5 mb-5'>
              <b-col v-for="interview in dayInterviews" cols='12' class='px-0' :key="interview.id">
                <b-card class="text-center">
                  <ul class="px-0 mb-0">
                    <li class="pb-2 news-li shortcut text-left d-flex justify-between">
                      <p class="px-4 m-auto">{{ dayFormat(interview.interview_date)}}</p>
                      <div class="row">
                        <b-img v-bind="mainProps" rounded="circle" alt="Circle image"></b-img>
                        <p class="contact-name mb-0 px-2">
                            {{ interview.name }} 
                        </p>
                      </div>
                      <p class="px-4 m-auto">{{interview.name}}</p>
                  
                      <b-button variant="outline-secondary" size="sm">
                        <router-link :to="'/mailbox?u_id=' + interview.organization_id">チャットをみる</router-link>
                      </b-button>
                    </li>
                  </ul>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-else>
                <h5 class="mx-auto pt-3 pb-3">面接の予定はありません</h5>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import jaLocale from "@fullcalendar/core/locales/ja";
import '@fullcalendar/common/main.css';
import '@fullcalendar/daygrid/main.css';

import moment from 'moment-timezone';
import axios from 'axios';

export default {
  components: {
    FullCalendar
  },
  data() {
    return{
      idToken: localStorage.idToken,
      mainProps: { blank: true, blankColor: '#777', width: 50, height: 50, class: 'm1' },
      interviews: [],
      dayInterviews: [],
      calendarOptions: {
        initialView: 'dayGridMonth',
        locale: jaLocale, // 日本語化
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
        },
        calendarWeekends: true, 
        plugins: [dayGridPlugin,timeGridPlugin, interactionPlugin],
        dateClick: this.handleDateClick,
        events: []
      },
      calendarPlugins: [ ],
      isShowDetailDate: false,
      selectDate: ""
    }
  },
  methods: {
	dayFormat(d) {
      if(d != null) {
        var d1 = moment.utc(d).add(1, 'hours')
        return moment.utc(d).format("HH:mm") + "~" + d1.format("HH:mm")
      } else {
        return "00:00~01:00"
      }
    },
    handleDateClick: function(info) {
      console.log(info)
      this.selectDate = info.dateStr
      this.fetchInterviews(info.dateStr).then(response => {
            this.dayInterviews = response.data.interviews
            this.dayInterviews.forEach((e) => {
              var d = moment.tz(e.interview_date, 'Asia/Tokyo').add(-9, 'hours')
              this.calendarOptions.events.push({title: "面接", date: d.format('YYYY-MM-DD HH:mm')})
            })
          })
      this.isShowDetailDate = true
    },
    fetchInterviews: function(d="") {
      return axios
        .get(process.env.VUE_APP_API + "/api/seeker/recruits/1/interviews?day=" + d, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    },
    initCalendar: function() {
      this.isShowDetailDate = false
      this.calendarOptions.events = []
      this.fetchInterviews()
            .then(response => {
              this.interviews = response.data.interviews
              this.interviews.forEach((e) => {
                var d = moment.tz(e.interview_date, 'Asia/Tokyo').add(-9, 'hours')
              
                this.calendarOptions.events.push({title: e.name + "様", date: d.format('YYYY-MM-DD HH:mm')})
              })
            })
    }
  },
  mounted(){
    this.initCalendar()
    this.$store.commit('setLoading', false)
  }
}

</script>

<style scoped lang="scss">
</style>
